import React from 'react';
import * as componentStyle from './caseStudyPostProduction.module.scss';
import { Heading } from '../../../interface/header.interface';
import HeadingComponent from '../../HeadingComponent/HeadingComponent';


export interface PostProductionInterface {
  heading: Heading[] | null;
  description: string | null;
}

export default function CaseStudyPostProduction({ data }: { data: PostProductionInterface | null }) {
  return (
    <>
      {(data?.heading && data.description) && (
        <section className={componentStyle.caseStudyPostProduction}>
          <div className={componentStyle.caseStudyPostProduction__container}>
            <div className={componentStyle.caseStudyPostProduction__headingArea}>
              {data?.heading && <HeadingComponent data={data.heading} />}

              <div className={componentStyle.caseStudyPostProduction__headingContext}>
                {data?.description && <div className={componentStyle.caseStudyPostProduction__headingDescripton} dangerouslySetInnerHTML={{ __html: data.description }}></div>}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}
